import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { AssetsChecklistJson } from "../../../DynamicFormsJson/MastersJSON/assetsChecklist";
import { getAssetsChecklist } from "../../../Slice/assetsChecklist.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import { assetsChecklistColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet, apiPost } from "../../../utils/api_service";
import { noInternetMsg, statusmsg } from "../../../config/messageconstant";
class AssetsChecklistTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {},
        };
    }

    onChangeStatus = (rowData) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            let status = "";
            if (rowData.isActive == 0) {
                status = 1;
            } else {
                status = 0;
            }
            showLoador({ loador: true });
            apiPost({
                url: endpoint.assetsChecklist + "/update-is-active?id=" + rowData.id +
                    "&status=" + status,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success) {
                    showNotification({ msg: statusmsg });
                    window.location.reload();
                }
            });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }

    };

    render() {
        const { assetsChecklist, getAssetsChecklist } = this.props;
        const { dynamicMasterData } = this.state;
        return (
            <>
                <DynamicMainScreen
                    dynamicMasterData={dynamicMasterData}
                    formPath={AssetsChecklistJson.formPath}
                    screenTitle={AssetsChecklistJson.screenTitle}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={false}
                    showAddButton={AssetsChecklistJson.showAddButton}
                    tableColumnsToFilter={AssetsChecklistJson.tableColumnsToFilter}
                    tableColumns={assetsChecklistColumns}
                    tableData={assetsChecklist?.assetsChecklist}
                    getTableData={getAssetsChecklist}
                    getTableDataById={true}
                    apiBaseURL={AssetsChecklistJson.apiBaseURL}
                    baseIdColumn={AssetsChecklistJson.baseIdColumn}
                    showDeleteIcon={true}
                    isActiveURLFalse={true}
                    isActiveURLFalseMethod={this.onChangeStatus}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    assetsChecklist: state.assetsChecklist,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getAssetsChecklist,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AssetsChecklistTable);
